var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKivra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "Kivra",
    style: {
      enableBackground: "new 0 0 118.7 24.7"
    },
    width: 80,
    height: 24,
    viewBox: "0 0 80 24",
    fill: "##8cc646",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8cc646",
    d: "M19.7411,2.0766H19.74a1.96,1.96,0,0,0-1.9562,1.96V17.6494c-4.7641-.3721-7.1406-2.2665-10.9109-6.658L12.6025,5.445A1.96,1.96,0,0,0,9.8786,2.6326L4.2218,8.1051V4.0328a1.96,1.96,0,1,0-3.92,0v15.69a1.96,1.96,0,1,0,3.92,0v-5.81a26.71,26.71,0,0,0,5.69,5.2531c2.6951,1.7114,5.7293,2.4718,9.8289,2.4718a1.96,1.96,0,0,0,1.96-1.96V4.0367A1.96,1.96,0,0,0,19.7411,2.0766Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cc646",
    d: "M79.5334,18.9843q-.0226-.0518-.0482-.1022l-.001-.001L72.08,3.2a1.96,1.96,0,0,0-3.5431,0l-6.86,14.538A12.7,12.7,0,0,1,52.0524,13.34a6.47,6.47,0,1,0-10.26-7.4242.0253.0253,0,0,0-.0074.0146l-3.8709,9.2962v.0058L36.1935,19.31a1.9406,1.9406,0,1,0,3.5805,1.4978l4.1011-9.8683L45.37,7.5023a2.5539,2.5539,0,1,1,3.0532,3.4954,1.9611,1.9611,0,0,0-.9249,3.167c4.3623,4.9821,7.938,7.5137,15.4045,7.5137a1.9593,1.9593,0,0,0,1.7733-1.1223l5.63-11.931,5.636,11.931a1.96,1.96,0,1,0,3.5912-1.5718Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cc646",
    d: "M40.3933,4.8374a1.9558,1.9558,0,1,0-3.5718-1.5947L35.6248,5.9213h-.0185l.017.0073-3.9366,8.8078L26.5519,3.2427a1.96,1.96,0,1,0-3.6482,1.4356,1.7073,1.7073,0,0,0,.0725.162l2.2052,4.9364,4.6455,10.6768a1.9611,1.9611,0,0,0,1.7844,1.1778h.15a1.96,1.96,0,0,0,1.7815-1.1778l4.645-10.68Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKivra);
export default __webpack_public_path__ + "static/media/kivra.b5fb2f5dc71f045a74dcda56154e0c67.svg";
export { ForwardRef as ReactComponent };